import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { About } from 'src/core/index';
import { AboutService } from 'src/core/index/services.index';

@Injectable({
  providedIn: 'root',
})
export class AboutServiceCustom extends AboutService {
  translateService = inject(TranslateService);

  override getAbout() {
    if (this.translateService.currentLang === 'en') {
      return of({
        title: 'H2IOSC Training Environment',
        body: `<p>
                  <strong>H2IOSC Training Environment</strong> is a training management platform designed to offer a highly interactive 
                  virtual learning environment. It was developed within the framework of WP8 - Training, Capacity Building, Engagement 
                  of the project H2IOSC - <strong>Humanities and cultural Heritage Italian Open Science Cloud</strong> by the 
                  <strong>Institute of Computational Linguistics "Antonio Zampolli"</strong> of the National 
                  Research Council with the support of <strong>E.T.T. S.p.A.</strong>.
              </p>
              <br />
              <p>
                  The platform allows users to spontaneously <strong>enroll in courses</strong>, offering a large catalogue of e-learning 
                  courses and the ability to participate in live events. Each user can <strong>create a personal page</strong> with an intuitive 
                  dashboard that allows them to keep track of courses in progress and access certifications obtained. 
                  Built-in chat and forum features allow <strong>interaction between users</strong> and the creation of virtual working groups. 
              </p>
              <br />
              <p>
                  The H2IOSC Training Environment platform is designed to be accessible and provide a smooth and inclusive 
                  learning experience through a simple interface compatible with different types of desktop and mobile devices. 
                  In addition, the platform <strong>emphasizes an interactive</strong> learning experience by supporting quizzes, simulations, and hands-on exercises.
              </p>`,
      } as About);
    }
    return of({
      title: 'H2IOSC Training Environment',
      body: `<p>
                <strong>H2IOSC Training Environment</strong> è una moderna <strong>piattaforma di gestione della
                    formazione</strong> progettata per offrire un ambiente di apprendimento virtuale altamente
                interattivo e personalizzabile. Sviluppata dall'azienda <strong>ETT</strong> in collaborazione con
                l’<strong>Istituto di Linguistica Computazionale "Antonio Zampolli"</strong> di Pisa, nell'ambito del
                progetto PNRR <strong>Humanities and cultural Heritage Italian Open Science Cloud</strong>.
            </p>
            <br />
            <p>
                La piattaforma consente agli utenti di <strong>Iscriversi ai corsi</strong> accedendo a un ampio
                catalogo di corsi, strutturati per soddisfare le esigenze di studenti, professionisti e organizzazioni;
                <strong>gestire la propria pagina personale</strong> con una dashboard intuitiva che permette di
                monitorare il progresso, consultare materiali didattici e accedere alle certificazioni ottenute;
                <strong>interagire con la community</strong> grazie a strumenti collaborativi come forum, chat e gruppi
                di lavoro virtuali, gli utenti possono scambiare idee, risolvere problemi e creare reti di
                apprendimento.
            </p>
            <br />
            <p>
                H2IOSC Training Environment è stato pensato per adattarsi a diverse esigenze, garantendo un’esperienza
                fluida e inclusiva attraverso un’interfaccia semplice da usare, sia per i principianti sia per utenti
                avanzati e compatibile con dispositivi desktop e mobile, per un apprendimento senza limiti di spazio o
                tempo. La piattaforma inoltre <strong>pone l’accento sull’interattività</strong> supportando quiz,
                simulazioni, esercitazioni pratiche e strumenti di gamification che rendono l’apprendimento più
                coinvolgente.
            </p>`,
    } as About);
  }
}
